// initial state of cart is declared here
const initialState = {
    totalCartItems: 0,
    cartItems: []
}

export default initialState;